


import React, { useEffect, useState } from "react";
import axios from "axios";
import ManagerHeader from "./ManagerHeader";
import Navbar from "./Navbar";
import DeleteIcon from "@mui/icons-material/Delete";

const BrandComplaint = () => {
  const [complaints, setComplaints] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
  const complaintsPerPage = 10;

  useEffect(() => {
    fetchComplaints();
  }, []);

  const fetchComplaints = async () => {
    try {
      const response = await axios.get(
        "https://server-side-influencer.onrender.com/manager/allcomplaints"
      );
      if (response.data.success) {
        setComplaints(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching complaints:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(
        `https://server-side-influencer.onrender.com/brand/deletemycomplaint/${id}`
      );
      // Refresh list after deletion
      setComplaints((prev) => prev.filter((item) => item._id !== id));
    } catch (error) {
      console.error("Error deleting complaint:", error);
    }
  };

  const indexOfLastComplaint = currentPage * complaintsPerPage;
  const indexOfFirstComplaint = indexOfLastComplaint - complaintsPerPage;
  const currentComplaints = complaints.slice(indexOfFirstComplaint, indexOfLastComplaint);

  const totalPages = Math.ceil(complaints.length / complaintsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <div className="fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      {/* Header */}
      <div className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
        <ManagerHeader page="Brand complaints" />
      </div>

      {/* Main Content */}
      <div className="flex-1 ml-10 mt-20 p-6 overflow-auto w-full">
        <h2 className="text-3xl font-bold text-gray-800 mb-6 text-center">
          Brand Complaints
        </h2>

        <div className="relative overflow-x-auto shadow-md sm:rounded-lg bg-white mt-4">
          {complaints.length === 0 ? (
            <div className="p-8 text-center text-gray-500 text-lg">
              No complaints found.
            </div>
          ) : (
            <>
              <table className="w-full text-sm text-left text-gray-500 mt-10 ml-5">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                  <tr>
                    <th className="px-6 py-3">Brand Name</th>
                    <th className="px-6 py-3">Email</th>
                    <th className="px-6 py-3">Subject</th>
                    <th className="px-6 py-3">Message</th>
                    <th className="px-6 py-3">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {currentComplaints.map((complaint, index) => (
                    <tr
                      key={complaint._id}
                      className="odd:bg-white even:bg-gray-50 border-b"
                      onMouseEnter={() => setHoveredRowIndex(index)}
                      onMouseLeave={() => setHoveredRowIndex(null)}
                    >
                      <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap flex items-center justify-between">
                        {complaint.brandName}
                        {hoveredRowIndex === index && (
                          <DeleteIcon
                            onClick={() => handleDelete(complaint._id)}
                            className="text-red-500 cursor-pointer ml-2 hover:text-red-700"
                          />
                        )}
                      </td>
                      <td className="px-6 py-4">{complaint.brandEmail}</td>
                      <td className="px-6 py-4">{complaint.subject}</td>
                      <td className="px-6 py-4">{complaint.message}</td>
                      <td className="px-6 py-4">
                        {new Date(complaint.createdAt).toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="flex justify-center mt-6 space-x-2">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
                  >
                    Prev
                  </button>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      className={`px-3 py-1 text-sm rounded ${
                        currentPage === index + 1
                          ? "bg-blue-500 text-white"
                          : "bg-gray-200 hover:bg-gray-300"
                      }`}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BrandComplaint;
